// extracted by mini-css-extract-plugin
export default {"questionContainer":"Question_questionContainer__vhqpr","numberOfAnswers":"Question_numberOfAnswers__UMn1K"};